import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  console.log('Auth guard checking login status for route:', state.url);
  console.log('Access token exists:', !!authService.getAccessToken());
  console.log('Is authenticated:', authService.isAuthenticated());
  
  // Check if user is logged in using AuthService
  if (authService.isAuthenticated()) {
    console.log('User is authenticated, allowing access to:', state.url);
    return true;
  }
  
  // If not logged in, redirect to login page
  console.log('User is not authenticated, redirecting to login');
  router.navigate(['/auth/login']);
  return false;
};